import {DropboxCreationScreen, DropboxUploadScreen} from 'pages/layouts'
import {RouteMap} from '../RouteMap'
import {RouteParamDropbox} from './RouteParamDropbox'

export const ROUTE_MAP_DROPBOX: RouteMap<RouteParamDropbox> = {
  dropbox_creation: {
    component: DropboxCreationScreen,
    path: '/creation',
    permission: 'user',
  },
  dropbox_upload: {
    component: DropboxUploadScreen,
    path: '/',
    permission: 'user',
  },
}
